import { Icon } from '@iconify/react';
import React from 'react';
import Slider from 'react-slick';
import Div from '../Div';
import NowShowingCard from '../NowShowingCard';

const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
  <div
    {...props}
    className={'slick-prev slick-arrow' + (currentSlide === 0 ? ' slick-disabled' : '')}
    aria-hidden="true"
    aria-disabled={currentSlide === 0}
  >
    <Icon icon="bi:arrow-left" />
  </div>
);

const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
  <div
    {...props}
    className={'slick-next slick-arrow' + (currentSlide === slideCount - 1 ? ' slick-disabled' : '')}
    aria-hidden="true"
    aria-disabled={currentSlide === slideCount - 1}
  >
    <Icon icon="bi:arrow-right" />
  </div>
);

export default function NowShowingSlider({ movies = [] }) {
  if (!movies.length) {
    return <p style={{ color: '#999' }}>No movies currently showing.</p>;
  }

  const settings = {
    dots: false,
    infinite: movies.length > 4,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 991, settings: { slidesToShow: 2, dots: true, arrows: false } },
      { breakpoint: 500, settings: { slidesToShow: 1, dots: true, arrows: false } },
    ],
  };

  return (
    <Slider {...settings} className="cs-gap-24 cs-arrow_style2">
      {movies.map((movie) => (
        <Div key={movie._id}>
          <NowShowingCard poster={movie.poster} title={movie.title} showTimes={movie.showTimes} />
        </Div>
      ))}
    </Slider>
  );
}
